import React from "react";
import { Form } from "./GoogleForm";

export const Contact = () => (
  <div className="min-h-screen px-10 mx-auto mt-5 mb-10">
    <Form />
  </div>
);
